/* =====================================================================
   Myso Sleep Shopify teması - global betik
   Ajax sepet çekmecesi, tahminli arama, çekmeceler, bildirim, modal,
   koleksiyon sıralama, yatay kaydırıcılar.
   ===================================================================== */
(function () {
  'use strict';
  const M = window.Myso || (window.Myso = {});
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const esc = s => String(s == null ? '' : s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const JSON_HEADERS = { 'Content-Type': 'application/json', Accept: 'application/json' };

  /* ---------------- para formatı (Shopify money_format) ---------------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = Number(cents) || 0;
    const fmt = format || M.moneyFormat || '{{amount}}';
    const re = /\{\{\s*(\w+)\s*\}\}/;
    const num = (n, precision, thousands = ',', decimal = '.') => {
      const [i, d] = (n / 100).toFixed(precision).split('.');
      return i.replace(/\B(?=(\d{3})+(?!\d))/g, thousands) + (d ? decimal + d : '');
    };
    const key = (fmt.match(re) || [])[1];
    const v = {
      amount: () => num(cents, 2),
      amount_no_decimals: () => num(cents, 0),
      amount_with_comma_separator: () => num(cents, 2, '.', ','),
      amount_no_decimals_with_comma_separator: () => num(cents, 0, '.', ','),
      amount_with_apostrophe_separator: () => num(cents, 2, "'", '.'),
      amount_no_decimals_with_space_separator: () => num(cents, 0, ' '),
      amount_with_space_separator: () => num(cents, 2, ' ', ','),
      amount_with_period_and_space_separator: () => num(cents, 2, ' ', '.')
    }[key];
    return fmt.replace(re, v ? v() : num(cents, 2));
  }
  const money = c => formatMoney(c);

  /* ---------------- çekmece / bildirim / modal ---------------- */
  let lastFocus = null;
  function open(id) {
    closeAll(true); lastFocus = document.activeElement;
    const el = document.getElementById(id); if (!el) return;
    el.classList.add('is-open'); el.setAttribute('aria-hidden', 'false');
    const ov = $('#overlay'); ov && ov.classList.add('is-on');
    document.body.style.overflow = 'hidden';
    if (id === 'search') setTimeout(() => { const q = $('#q'); q && q.focus(); }, 250);
    else { const b = el.querySelector('button, a, input'); b && b.focus(); }
  }
  function closeAll(silent) {
    $$('.drawer.is-open, .search.is-open').forEach(el => { el.classList.remove('is-open'); el.setAttribute('aria-hidden', 'true'); });
    const ov = $('#overlay'); ov && ov.classList.remove('is-on');
    document.body.style.overflow = '';
    if (!silent && lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function toast(msg) {
    const t = $('#toast'); if (!t) return;
    t.textContent = msg; t.classList.add('is-on');
    clearTimeout(toast._t); toast._t = setTimeout(() => t.classList.remove('is-on'), 3600);
  }
  function modal(title, html) {
    const d = $('#modal'); if (!d) return;
    $('#modal-t').textContent = title; $('#modal-b').innerHTML = html;
    d.showModal ? d.showModal() : d.setAttribute('open', '');
  }

  /* ---------------- AJAX SEPET ---------------- */
  const imgUrl = (src, w) => src ? src + (src.includes('?') ? '&' : '?') + 'width=' + w : '';
  const Cart = {
    data: null,
    async fetch() {
      const r = await fetch(M.routes.cart + '.js', { headers: { Accept: 'application/json' } });
      this.data = await r.json(); this.render(); return this.data;
    },
    async add(items, opts = {}) {
      const r = await fetch(M.routes.cartAdd + '.js', { method: 'POST', headers: JSON_HEADERS, body: JSON.stringify({ items }) });
      const j = await r.json().catch(() => ({}));
      if (!r.ok) throw new Error(j.description || j.message || M.strings.cartError);
      await this.fetch();
      document.dispatchEvent(new CustomEvent('myso:cart-updated', { detail: this.data }));
      if (!opts.silent) { if (M.cartType === 'page') location.href = M.routes.cart; else open('cart'); }
      return j;
    },
    async change(key, quantity) {
      const r = await fetch(M.routes.cartChange + '.js', { method: 'POST', headers: JSON_HEADERS, body: JSON.stringify({ id: key, quantity }) });
      const j = await r.json().catch(() => ({}));
      if (!r.ok) { toast(j.description || j.message || M.strings.cartError); return this.fetch(); }
      this.data = j; this.render();
      document.dispatchEvent(new CustomEvent('myso:cart-updated', { detail: this.data }));
    },
    protectionLine() { return M.protectionVariant && this.data ? this.data.items.find(i => i.variant_id === M.protectionVariant) : null; },
    render() {
      const c = this.data; if (!c) return;
      const prot = this.protectionLine();
      const items = c.items.filter(i => !prot || i.key !== prot.key);
      const n = items.reduce((a, i) => a + i.quantity, 0);
      $$('.cart-count').forEach(b => { b.textContent = n; b.dataset.n = n; });
      if (!$('#cart-n')) return;
      $('#cart-n').textContent = n;
      const sub = c.total_price - (prot ? prot.final_line_price : 0);
      const ship = $('#ship');
      if (M.freeShipping > 0) {
        const left = Math.max(0, M.freeShipping - sub);
        ship.innerHTML = `${left > 0 ? M.strings.freeLeft.replace('[amount]', `<b>${money(left)}</b>`) : M.strings.freeDone}<div class="ship__bar"><i style="--w:${Math.min(100, sub / M.freeShipping * 100)}%"></i></div>`;
        ship.hidden = false;
      } else ship.hidden = true;

      const tpl = $('#cart-upsell');
      const inCart = new Set(items.map(i => i.handle));
      const ups = tpl ? Array.from(tpl.content.querySelectorAll('.mini')).filter(m => !inCart.has(m.dataset.handle)) : [];
      const upsHTML = (k, title, sub2) => ups.length ? `<div class="upsell">${title ? `<h4>${title}</h4>` : ''}${sub2 ? `<h5>${sub2}</h5>` : ''}${ups.slice(0, k).map(m => m.outerHTML).join('')}</div>` : '';

      if (!n) {
        $('#cart-body').innerHTML = upsHTML(4, esc(M.strings.cartEmpty), esc(this.upsellTitle || '')) || `<div class="upsell"><h4>${esc(M.strings.cartEmpty)}</h4></div>`;
        $('#cart-foot').innerHTML = `<button class="btn btn--xl" type="button" data-close>${esc(M.strings.continue)}</button>`;
        return;
      }
      $('#cart-body').innerHTML = `<div class="cart-lines">${items.map(i => {
        const props = Object.entries(i.properties || {}).filter(([k, v]) => v && k.charAt(0) !== '_').map(([k, v]) => `<li>${esc(k)}: ${esc(v)}</li>`).join('');
        const disc = (i.line_level_discount_allocations || []).map(d => `<li class="cline__disc">${esc(d.discount_application.title)} (−${money(d.amount)})</li>`).join('');
        const vt = i.variant_title && i.product_has_only_default_variant === false ? `<li>${esc(i.variant_title)}</li>` : '';
        return `<div class="cline" data-key="${esc(i.key)}">
          <a class="cline__img m-lilac" href="${esc(i.url)}">${i.image ? `<img src="${esc(imgUrl(i.image, 160))}" alt="" width="76" height="76" loading="lazy">` : ''}</a>
          <div><div class="cline__t">${esc(i.product_title)}</div><ul class="cline__v">${vt}${props}${disc}</ul>
            <div class="qty"><button type="button" data-q="-1" aria-label="−">${'<svg aria-hidden="true"><use href="#i-minus"/></svg>'}</button><span>${i.quantity}</span><button type="button" data-q="1" aria-label="+">${'<svg aria-hidden="true"><use href="#i-plus"/></svg>'}</button></div>
            <button class="cline__rm" type="button" data-rm>${esc(M.strings.remove)}</button></div>
          <div class="cline__p">${money(i.final_line_price)}${i.original_line_price > i.final_line_price ? `<s>${money(i.original_line_price)}</s>` : ''}</div>
        </div>`;
      }).join('')}</div>${upsHTML(2, '', this.upsellTitle || '')}`;
      $('#cart-foot').innerHTML = `
        ${M.protectionVariant ? `<label class="switch"><input type="checkbox" id="protect" ${prot ? 'checked' : ''}> ${esc(this.protectionLabel || '')}</label>` : ''}
        <div class="totals"><span>${esc(M.strings.total)}</span><span>${money(c.total_price)}</span></div>
        ${c.total_discount > 0 ? `<div class="totals totals--save"><span>${esc(M.strings.saved)}</span><span>${money(c.total_discount)}</span></div>` : ''}
        <form action="${esc(M.routes.cart)}" method="post">${this.legalHTML || ''}<button class="btn btn--xl" type="submit" name="checkout">${esc(M.strings.checkout)}</button></form>
        <a href="#" class="drawer__cont" data-close>${esc(M.strings.continue)}</a>`;
      const lg = $('#cart-foot [data-legal]'); if (lg) lg.checked = !!this.legalOk;
    },
    bind() {
      const drawer = $('#cart'); if (!drawer) return;
      this.upsellTitle = drawer.dataset.upsellTitle || '';
      this.protectionLabel = drawer.dataset.protectionLabel || '';
      const lt = $('#legal-tpl'); this.legalHTML = lt ? lt.innerHTML.trim() : '';
      $('#cart-body').addEventListener('click', e => {
        const line = e.target.closest('.cline'); if (!line) return;
        const it = this.data.items.find(i => i.key === line.dataset.key); if (!it) return;
        const b = e.target.closest('[data-q]'); if (b) this.change(it.key, it.quantity + (+b.dataset.q));
        if (e.target.closest('[data-rm]')) this.change(it.key, 0);
      });
      $('#cart-foot').addEventListener('change', async e => {
        if (e.target.matches('[data-legal]')) { this.legalOk = e.target.checked; return; }
        if (e.target.id !== 'protect') return;
        e.target.disabled = true;
        try {
          if (e.target.checked) await this.add([{ id: M.protectionVariant, quantity: 1 }], { silent: true });
          else { const p = this.protectionLine(); if (p) await this.change(p.key, 0); }
        } catch (err) { toast(err.message); this.render(); }
      });
    }
  };

  /* ---------------- tahminli arama ---------------- */
  function bindSearch() {
    const q = $('#q'); if (!q) return;
    let t = null, ctrl = null;
    const label = $('#search-label'), res = $('#search-res');
    const base = label ? label.textContent : '';
    const run = async v => {
      v = v.trim();
      if (!v) { res.innerHTML = ''; label.textContent = base; return; }
      ctrl && ctrl.abort(); ctrl = new AbortController();
      try {
        const r = await fetch(`${M.routes.predictive}.json?q=${encodeURIComponent(v)}&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last`, { signal: ctrl.signal });
        const j = await r.json(); const ps = (j.resources && j.resources.results && j.resources.results.products) || [];
        label.textContent = (ps.length ? M.strings.searchResults : M.strings.searchNone).replace('[terms]', v).replace('[count]', ps.length);
        res.innerHTML = ps.map(p => {
          const img = (p.featured_image && p.featured_image.url) || p.image;
          return `<a class="search__item" href="${esc(p.url)}"><div class="m-lilac">${img ? `<img src="${esc(imgUrl(img, 360))}" alt="" loading="lazy">` : ''}</div><p><b>${esc(p.title)}</b>${money(Math.round(parseFloat(p.price) * 100))}</p></a>`;
        }).join('');
      } catch (err) { if (err.name !== 'AbortError') label.textContent = base; }
    };
    q.addEventListener('input', () => { clearTimeout(t); t = setTimeout(() => run(q.value), 220); });
    const chips = $('#search-chips');
    chips && chips.addEventListener('click', e => { const b = e.target.closest('[data-q]'); if (b) { q.value = b.dataset.q; run(b.dataset.q); } });
  }

  /* ---------------- genel olaylar ---------------- */
  function bind() {
    document.addEventListener('click', e => {
      const o = e.target.closest('[data-open]');
      if (o) {
        if (o.dataset.open === 'cart' && (M.cartType === 'page' || !$('#cart'))) return;
        e.preventDefault(); open(o.dataset.open); return;
      }
      if (e.target.closest('[data-close]') || e.target.id === 'overlay') { e.preventDefault(); closeAll(); return; }
      if (e.target.closest('[data-modal-close]')) { $('#modal').close(); return; }
      const hs = e.target.closest('[data-hs]');
      if (hs) { const tr = document.querySelector(hs.dataset.hs); tr && tr.scrollBy({ left: (hs.classList.contains('hs-btn--prev') ? -1 : 1) * tr.clientWidth * 0.8, behavior: 'smooth' }); }
      const nx = e.target.closest('[data-carousel-next]');
      if (nx) {
        const tr = document.querySelector(nx.dataset.carouselNext); if (!tr) return;
        const card = tr.firstElementChild; const step = card ? card.offsetWidth + 16 : tr.clientWidth;
        const end = tr.scrollLeft + tr.clientWidth >= tr.scrollWidth - 4;
        tr.scrollTo({ left: end ? 0 : tr.scrollLeft + step, behavior: 'smooth' });
      }
    });
    document.addEventListener('keydown', e => { if (e.key === 'Escape') closeAll(); });
    // koleksiyon sıralama
    $$('[data-sort]').forEach(s => s.addEventListener('change', () => { const u = new URL(location.href); u.searchParams.set('sort_by', s.value); u.searchParams.delete('page'); location.href = u.toString(); }));
    // destek formu: hata olan ilk alana odaklan
    const err = $('.field.is-err input, .field.is-err textarea'); err && err.focus();
  }

  Object.assign(M, { money, formatMoney, toast, modal, open, closeAll, cart: Cart, esc });
  function boot() {
    bind(); bindSearch(); Cart.bind();
    if ($('#cart') || $('.cart-count')) Cart.fetch().catch(() => { });
    document.dispatchEvent(new Event('myso:ready'));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
